export default __webpack_public_path__ + "static/media/clinical-pilates-3.3c58e5c1.png";